import(/* webpackMode: "eager" */ "/vercel/path0/nextjs/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviderWrapper"] */ "/vercel/path0/nextjs/contexts/AppContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/nextjs/providers/ClientProvider.tsx");
